module.exports = __webpack_public_path__ + "img/pocket-17_jp.5070b4e.jpg";